module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm7-4b927b7694092e5b1844cd4fef361830.jpg";